import { render, staticRenderFns } from "./ConfigEmployeeAttendance.vue?vue&type=template&id=5ddd5626&scoped=true"
import script from "./ConfigEmployeeAttendance.vue?vue&type=script&lang=js"
export * from "./ConfigEmployeeAttendance.vue?vue&type=script&lang=js"
import style0 from "./ConfigEmployeeAttendance.vue?vue&type=style&index=0&id=5ddd5626&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd5626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ddd5626')) {
      api.createRecord('5ddd5626', component.options)
    } else {
      api.reload('5ddd5626', component.options)
    }
    module.hot.accept("./ConfigEmployeeAttendance.vue?vue&type=template&id=5ddd5626&scoped=true", function () {
      api.rerender('5ddd5626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/ConfigEmployeeAttendance.vue"
export default component.exports